import sellerOffers from "@/../store/modules/sellerOffers.js";

function _checkOffersAvailabilitySetting(offerType) {
  let settings;

  switch (offerType) {
    case "SPOT":
      settings = sellerOffers.state.offersAvailability.spot;
      break;
    case "CONTRACTS":
      settings = sellerOffers.state.offersAvailability.contracts.spot;
      break;
    case "DELIVERED_IN":
      settings = sellerOffers.state.offersAvailability.deliveredIn;
      break;
    default:
      break;
  }

  // Let's check whether seller has enabled this offer type and its available hours
  if (!settings.enabled || !_checkOffersAvailabilityHours(settings.start, settings.end)) {
    return false;
  }

  return true;
}

function _checkOffersAvailabilityHours(startTime, endTime) {
  const currentTime = new Date();
  const start = new Date().setHours(startTime.substring(0, 2), startTime.substring(3));
  const end = new Date().setHours(endTime.substring(0, 2), endTime.substring(3));

  return start <= currentTime && currentTime <= end;
}

function recommendedOfferQuery(
  sellerAccountId,
  buyerAccountId,
  { terminalId, collectionTime, isContract, deliveredInData, networks, fuels, liftingPeriod },
  includeAuditTrail = false
) {
  const query = {
    sellerAccountIds: [sellerAccountId],
    platform: "OLFUK",
    buyerAccountId,
    includeAuditTrail,
  };
  if (fuels) query.fuels = fuels;
  if  (liftingPeriod) query.liftingPeriod = liftingPeriod;

  if (networks) {
    query.queryType = isContract ? "CONTRACT_BUNK" : "BUNK";
    query.networks = networks;
  } else {
    query.queryType = "EX";
    if (terminalId) query.terminals = [terminalId];
    query.days = collectionTime;

    if (isContract) {
      query.queryType = "CONTRACT_EX";
    } else if (deliveredInData) {
      query.queryType = "DIN";
      query.postcode = deliveredInData.location.postCode;
      query.days = deliveredInData.deliveryDate;
    }
  }
  return query;
}

function calculateFinalCustomerMargin(offer) {
  if (!offer.offerPricingBreakdown) {
    return 0;
  }

  return offer.offerPricingBreakdown.customerMargin + Number(offer.adjustment);
}

function calculateQuotePrice(offer) {
  const { price, adjustment } = offer;
  const quotePrice = Number(price.toFixed(2)) + Number(adjustment);
  return quotePrice;
}

function calculateOrderItemPrice(volume, offerPricePpl) {
  const itemPrice = (Number(volume) * Number(offerPricePpl)) / 100; // returns price in GBP rather than pence
  return Number(itemPrice.toFixed(2));
}

function calculateFinalOfferPriceAndMargin(offer) {
  const finalCustomerMargin = calculateFinalCustomerMargin(offer);
  const quotePrice = calculateQuotePrice(offer);
  const totalPrice = calculateOrderItemPrice(offer.quantity, quotePrice);
  return { finalCustomerMargin, quotePrice, totalPrice };
}

function calculateCurrentMaxAvailableVolWithBasket(offerId, maxAvailableVol, basketItems) {
  const matchingBasketItems = basketItems.filter((item) => item._id === offerId);
  let currentMaxAvailable = maxAvailableVol;
  matchingBasketItems.forEach(({ quantity }) => (currentMaxAvailable -= quantity));
  return currentMaxAvailable;
}
export {
  _checkOffersAvailabilitySetting,
  _checkOffersAvailabilityHours,
  recommendedOfferQuery,
  calculateOrderItemPrice,
  calculateFinalCustomerMargin,
  calculateFinalOfferPriceAndMargin,
  calculateCurrentMaxAvailableVolWithBasket,
};
